import React from "react";
import { Link } from "react-router-dom";
import { CDN_BASE_URL } from "../../../config";

const BlogCardImage = ({ data, handleChangeSetBlog }) => {
  return (
    <span onClick={() => handleChangeSetBlog(data?._id)} className="relative">
      <img
        src={CDN_BASE_URL + data?.cover}
        className="w-full rounded-[10px] object-cover h-[260px]"
        alt=""
      />
      <div className="absolute w-full bottom-0 right-0 p-3 bg_gradiant text-white text-[700] text-[20px]">
        {data?.name}
      </div>
    </span>
  );
};

export default BlogCardImage;
